import React, { Component } from 'react'

import { bemClasses } from '../../../utils/bem'

import Button from '../../button'
import Input from '../input'
import Wrapper from '../../wrapper'

import './styles.scss'

class InputWithButton extends Component {
  constructor () {
    super()

    this.state = {
      value:     '',
      submitted: false
    }
  }

  componentWillMount = () => {
    this.storeNewProps()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.value !== prevProps.value) {
      this.storeNewProps()
    }
  }

  storeNewProps = () => {
    this.setState({ value: this.props.value, submitted: !!this.props.value })
  }

  componentClassNames = () => {
    return bemClasses('input-with-button', ['fullWidth'], this.props)
  }

  renderButton = () => {
    return (
      <Button
        {...this.props.button}
        type={'submit'}
        attached
        green
        searchIcon
      />
    )
  }

  renderClearButton = () => {
    if (this.state.value && this.state.submitted) {
      return (
        <Button
          attached
          onClick={this.onClear}
          yellow
          crossIcon
        />
      )
    }
  }

  onClear = () => {
    this.setState({ value: null, submitted: false })
    this.props.onSubmit(null)
  }

  onSubmit = (event) => {
    event.preventDefault()

    this.setState({ submitted: true })
    this.props.onSubmit(this.state.value)
  }

  onChange = (value) => {
    this.setState({ value: value })
  }

  render = () => {
    return (
      <form onSubmit={this.onSubmit} className={this.componentClassNames()}>
        <Wrapper>
          <Input
            onChange={this.onChange}
            value={this.state.value}
            placeholder={this.props.placeholder}
            name={this.props.name}
            type={this.props.type}
            required={this.props.required}
            disabled={this.props.disabled}
            withAttachedButton
          />

          { this.renderButton() }
          { this.renderClearButton() }
        </Wrapper>
      </form>
    )
  }
}

export default InputWithButton
